import { NavigationGuard } from "vue-router"
import { ref } from "vue"
import { ScrapingStore } from "../store/Scraping"

import api from '@samsungfireObesity/api/Scraping'
import adminApi from '@samsungfireObesity/api/admin'

export { accessGuard, GetServiceName, initGuard, LoginGuard }

const GetServiceName: NavigationGuard = async (to, from, next) =>  {
    const scrapingState = ScrapingStore();

    if (to.name == 'agree') {
        sessionStorage.setItem('serviceName', 'obesity');
        scrapingState.serviceName = 'obesity';
        scrapingState.pageTitle = '키,몸무게 정보 제공동의';
    }
    else if (to.name == 'agree-admCritical') {
        sessionStorage.setItem('serviceName', 'admCritical');
        scrapingState.serviceName = 'admCritical';
        scrapingState.pageTitle = '의료정보 제공동의';
    }

    next();
}

const accessGuard: NavigationGuard = async (to, from, next) =>  {
    const scrapingState = ScrapingStore();

    if (scrapingState.serviceName == undefined || scrapingState.serviceName == '') {
        scrapingState.serviceName = sessionStorage.getItem('serviceName') || '';
    }

    const nextRoute = ref<string>('result');
    nextRoute.value = scrapingState.serviceName == 'obesity' ? 'result' : 'result-admCritical';

    const { query } = to;

    if (to.name == 'result' || to.name == 'result-admCritical') {
        return next();
    }

    if (to.name == 'confirm' && from.name != 'request') {
        next({ name: 'request', query: { receiptId: query.receiptId!.toString() }})
    }

    if (to.name == 'confirm-admCritical' && from.name != 'request-admCritical') {
        next({ name: 'request-admCritical', query: { receiptId: query.receiptId!.toString() }})
    }

    if (!query.receiptId) {
        next({ name: nextRoute.value, params: { code: '2002' } })
    }

    const isValidReceiptId = ref<boolean>(false);
    isValidReceiptId.value = await ValidReceiptId(query.receiptId!.toString());

    if (isValidReceiptId.value) {
        next()
    } else {
        next({ name: nextRoute.value, params: { code: '2002' }, query: { receiptId: query.receiptId!.toString() }})
    }

    /*
    const isExpireReceiptId = ref<boolean>(false);
    isExpireReceiptId.value = await ExpireReceiptId(query.receiptId!.toString());
    
    if (isExpireReceiptId.value) {
        next()
    } else {
        next({ name: 'result', params: { code: '4000' }, query: { receiptId: query.receiptId!.toString() }})
    }
    */
}

const ValidReceiptId = async (receiptId: string) => {
    const scrapingState = ScrapingStore();

    const result = await api.IsValidReceiptId(scrapingState.serviceName, receiptId).then((res: CommonResponse<boolean>) => {
        if (res.errorCode == '0000' && res.data) {
            scrapingState.scrapingReq.receiptId = receiptId;
            return true;
        }
        else {
            return false;
        }
            
    })

    return result
}

const initGuard: NavigationGuard = async (to, from, next) => {
    const scrapingState = ScrapingStore();
    const nextRoute = ref<string>('');
    nextRoute.value = scrapingState.serviceName == 'obesity' ? 'result' : 'result-admCritical';

    const { query } = to;

    if (!query.receiptId) {
        next({ name: nextRoute.value, params: { code: '2002' } })
    }

    const status = await api.GetStatus(scrapingState.serviceName, query.receiptId!.toString()).then((res: CommonResponse<boolean>) => {
        return res.errorCode;
    }).catch(() => {
        return '9999';
    })

    if (status == '0000') {
        next({ name: nextRoute.value, params: { code: '0000' }, query: { receiptId: query.receiptId!.toString() }})
    }
    else if (status == '4000') {
        next({ name: nextRoute.value, params: { code: '4000' }, query: { receiptId: query.receiptId!.toString() }})
    }
    else if (status == '2001') {
        next({ name: nextRoute.value, params: { code: '2001' }, query: { receiptId: query.receiptId!.toString() }})
    }
    else if (status == '2000') {
        next();
    }
    else {
        next({ name: nextRoute.value, params: { code: '9999' }, query: { receiptId: query.receiptId!.toString() }})
    }
}

const LoginGuard: NavigationGuard = async (to, from, next) => {
    await adminApi.Current()
        .then(() => {
            if (to.name !== 'list') {
                next({ name: 'list' });
            } else {
                next();
            }
        })
        .catch(() => {
            if (to.name !== 'login') {
                next({ name: 'login' });
            } else {
                next();
            }
        });
}

/*
const ExpireReceiptId = async (receiptId: string) => {
    const scrapingState = ScrapingStore();
    
    const result = await api.isExpireReceiptId(scrapingState.serviceName, receiptId).then((res: CommonResponse<boolean>) => {
        if (res.errorCode == '0000') {
            return res.data;
        } else {
            return false;
        }
    })

    return result
}
*/